/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	/***
	 *
	 * POWER CUSTOM CODE FOR ADAPEI 07
	 *
	 */

	/***
	 * Accessibilité des boutons d'interface des lecteurs audios
	 *
	 */
	var 
	  	$player = jQuery(".audio-ctrl");

	  	jQuery(".audio-ctrl").each(function(){

	    	jQuery(this).attr("aria-pressed","false");

	    	jQuery(this).click(function(e){
	      		e.preventDefault();

	      		$player.attr("aria-pressed","false");

	      		if(jQuery(this).hasClass("play")){
	        		jQuery("#player")[0].play();
	        		jQuery(this).attr("aria-pressed","true");
	      		}
	      		if(jQuery(this).hasClass("pause")){
	        		jQuery("#player")[0].pause();
	        		jQuery(this).attr("aria-pressed","true");
	      		}
	      		if(jQuery(this).hasClass("read")){
	      			jQuery("#player")[0].pause();
	      			jQuery("#player")[0].currentTime = 0;
	      			jQuery(this).attr("aria-pressed","true");
				    jQuery('html, body').animate({
				        scrollTop: jQuery('[name="read"]').offset().top
				    }, 500);
	      		}
	    	});
		});

	/***
	 * Progress bar diapositive & Accessibilité start/pause button
	 *
	 */
	progress(80, jQuery('.progress-meter'));

    function progress(percent, $element) {
        var progressBarWidth = percent * $element.width() / 100;
        $element.animate({ width: progressBarWidth }, 5000).html(percent + "% ");
    }

	/***
	 * Display and hide arrow up when you scrool
	 *	
	 */
	jQuery(window).scroll( onWindowScroll );

	/***
	 * Retour en haut de la page
	 *
	 */
  	jQuery('.top-button').on('click', function(event) {
    	event.preventDefault();
    	jQuery('html, body').animate({scrollTop:0}, 'slow');
    	return false;
  	});

	/***
	 * Helper : class smooth anchor between section and link
	 * Use name="" attribute on your section
	 */
	jQuery('a.smooth').click(function(event) {
	    event.preventDefault();
	    jQuery('html, body').animate({
	        scrollTop: jQuery('[name="' + jQuery.attr(this, 'href').substr(1) + '"]').offset().top
	    }, 500);
	    return false;
	});

	/***
	 * Parralax class settings
	 *
	 */
	jQuery('.img-parallax').each(function(){
	  var img = jQuery(this);
	  var imgParent = jQuery(this).parent();
	  function parallaxImg () {
	    var speed = img.data('speed');
	    var imgY = imgParent.offset().top;
	    var winY = jQuery(this).scrollTop();
	    var winH = jQuery(this).height();
	    var parentH = imgParent.innerHeight();


	    // The next pixel to show on screen      
	    var winBottom = winY + winH;

	    // If block is shown on screen
	    if (winBottom > imgY && winY < imgY + parentH) {
	      // Number of pixels shown after block appear
	      var imgBottom = ((winBottom - imgY) * speed);
	      // Max number of pixels until block disappear
	      var imgTop = winH + parentH;
	      // Porcentage between start showing until disappearing
	      var imgPercent = ((imgBottom / imgTop) * 100) + (50 - (speed * 50));
	    }
	    img.css({
	      top: imgPercent + '%',
	      transform: 'translate(-50%, -' + imgPercent + '%)'
	    });
	  }
	  jQuery(document).on({
	    scroll: function () {
	      parallaxImg();
	    }, ready: function () {
	      parallaxImg();
	    }
	  });
	});

	/***
	 * Ajax request for ADAPEI map
	 *
	 */
	jQuery(document).on('click', '.marker', function(e) {

		var $marker = jQuery(this);
		var $modal = jQuery('#structureModal');

	  	var ajax_url = $modal.data("ajax-url");
	  	var structures = $marker.data("structures");

	  	if (ajax_url) {
	  		$modal.foundation('open');
	    	$modal.find('.reveal-information').html("<p class='loading text-center'><i class='material-icons animated infinite rotateIn'>autorenew</i> Chargement en cours.. Veuillez patienter</p>");
			jQuery.post(
			    ajaxurl,
			    {
			        'action': ajax_url,
			        'structures_id': structures
			    },
			    function(response){
					$modal.find('.reveal-information').html(response);
				}
			);
	  	}
	});


});


	/***
	 * Display and hide arrow up when you scrool
	 *	
	 */
	function onWindowScroll(_event) {        
	  	/* beam me up */
	  	if (jQuery(this).scrollTop() > 400) {
	    	jQuery('.to-the-top').fadeIn(700);    
	  	} else {
	    	jQuery('.to-the-top').fadeOut(700);
	  	}
	}